


import React, { useEffect, useRef, useState } from "react";
import IconButton from "@mui/material/IconButton";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import {
  Box,
  Button,
  Paper,
  Typography,
  Grid,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  MenuItem,
  DialogActions,
  DialogTitle,
  DialogContent,
  Dialog,
  Autocomplete,
  Radio,
  RadioGroup,
  List,
  ListItemText,
  ListItem,
  TextField,
  FormControlLabel,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import SaveIcon from "@mui/icons-material/Save";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import MoveToInboxIcon from "@mui/icons-material/MoveToInbox";
import dayjs from "dayjs";
import depotMasterService from '../../../services/masters/depotMaster.Service.js';
import productMasterService from '../../../services/masters/productMaster.Service.js';
import cylinderMasterService from '../../../services/masters/cylinderMaster.Service.js';
import vehicleMasterService from '../../../services/masters/vehicleMaster.Service.js';
import driverMasterService from '../../../services/masters/driverMaster.Service.js';
import customerMasterService from '../../../services/masters/customerMaster.Service.js';
import inwardService from "../../../services/inward.Service.js";
import ReusableSnackbar from "../../reusableComponent/ReusableSnackbar.jsx";
import plantMasterService from "../../../services/masters/plantMaster.Service.js";
import DeliveryChallanService from "../../../services/deliveryChallan.Service.js";
import emptycallanservice from "../../../services/empty_delivery_challan.js";
import LocalPrintshopIcon from '@mui/icons-material/LocalPrintshop';
import { Html5Qrcode } from "html5-qrcode";
import CameraAltSharpIcon from '@mui/icons-material/CameraAltSharp';
import CancelIcon from '@mui/icons-material/Cancel';
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import supplierMasterService from "../../../services/masters/supplierMaster.Service.js";
import salesreturnServices from "../../../services/salesreturn.services.js";

// ── Shared styles ─────────────────────────────────────────────────────────────

const pageSx = {
  background: "#F4F7FB",
  minHeight: "100vh",
  padding: "20px 24px 40px",
  fontFamily: "'Inter', Arial, sans-serif",
};

const breadcrumbSx = {
  fontSize: "12px",
  color: "#718096",
  mb: 2,
  display: "flex",
  alignItems: "center",
  gap: "6px",
};

const pageHeaderSx = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  mb: 2.5,
};

const pageTitleSx = {
  fontSize: "16px",
  fontWeight: 700,
  color: "#000000",
  display: "flex",
  alignItems: "center",
  gap: "10px",
};

const backBtnSx = {
  display: "flex",
  alignItems: "center",
  gap: "6px",
  fontSize: "13px",
  fontWeight: 600,
  color: "#2B6CB0",
  padding: "7px 14px",
  border: "1.5px solid #2B6CB0",
  borderRadius: "7px",
  background: "#fff",
  cursor: "pointer",
  textTransform: "none",
  "&:hover": { background: "#E6F1FB" },
};

const formCardSx = {
  background: "#fff",
  border: "1px solid #E2E8F0",
  overflow: "hidden",
  mb: 2,
};

const sectionHeaderSx = {
  background: "#1C3A5E",
  padding: "12px 22px",
  display: "flex",
  alignItems: "center",
  gap: "10px",
};

const sectionHeaderTitleSx = {
  fontSize: "13px",
  fontWeight: 600,
  color: "#fff",
  letterSpacing: "0.3px",
};

const formBodySx = { padding: "20px 22px" };

const fieldLabelSx = {
  fontSize: "12px",
  fontWeight: 600,
  color: "#2063b6",
  mb: "4px",
  display: "flex",
  alignItems: "center",
  gap: "4px",
};

const inputSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "8px",
    fontSize: "13px",
    fontFamily: "'Inter', Arial, sans-serif",
    background: "#fafafa",
    height: "36px",
    "& fieldset": { borderColor: "#E2E8F0", borderWidth: "1.5px" },
    "&:hover fieldset": { borderColor: "#CBD5E0" },
    "&.Mui-focused fieldset": { borderColor: "#2B6CB0", borderWidth: "2px" },
    "&.Mui-focused": { background: "#fff" },
    "&.Mui-disabled": { background: "#F8FAFC" },
  },
  "& input": {
    color: "#1A202C",
    fontSize: "13px",
    fontFamily: "'Inter', Arial, sans-serif",
    "&::placeholder": { color: "#A0AEC0", opacity: 1 },
  },
  "& .MuiInputLabel-root": { display: "none" },
};

const readonlyInputSx = {
  ...inputSx,
  "& .MuiOutlinedInput-root": {
    ...inputSx["& .MuiOutlinedInput-root"],
    background: "#F0F4F8",
  },
};

const selectSx = {
  ...inputSx,
  "& .MuiOutlinedInput-root": {
    ...inputSx["& .MuiOutlinedInput-root"],
    height: "36px",
  },
};

const menuItemSx = { fontSize: "13px", fontFamily: "'Inter', Arial, sans-serif" };

const formFooterSx = {
  padding: "18px 24px",
  background: "#F8FAFC",
  borderTop: "1px solid #E2E8F0",
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  gap: "10px",
};

const saveBtnSx = {
  display: "flex",
  alignItems: "center",
  gap: "7px",
  padding: "0 22px",
  height: "40px",
  background: "#4CAF50",
  color: "#fff",
  border: "none",
  fontSize: "14px",
  fontWeight: 600,
  textTransform: "none",
  borderRadius: "8px",
  fontFamily: "'Inter', Arial, sans-serif",
  "&:hover": { background: "#028b19", transform: "translateY(-1px)" },
  "&:active": { transform: "translateY(0)" },
  "&.Mui-disabled": { background: "#94a3b8", color: "#fff" },
  transition: "all 0.15s ease",
};

const cancelBtnSx = {
  display: "flex",
  alignItems: "center",
  gap: "7px",
  padding: "0 22px",
  height: "40px",
  background: "#E53E3E",
  color: "#ffffff",
  border: "none",
  "&:hover": { background: "#971f16", transform: "translateY(-1px)" },
  fontSize: "14px",
  fontWeight: 600,
  borderRadius: "8px",
  textTransform: "none",
};

// ─────────────────────────────────────────────────────────────────────────────

const CylinderInwardAdd = () => {
  const login_details = sessionStorage.getItem('loginUser');
  const userD = JSON.parse(login_details);
  const userInfo = userD.result.userInfo;
  const unit_id = userInfo.depot_id || userInfo.plant_id;
  const depot_id = userInfo.depot_id;
  const short_code = userInfo.depot_short_code || userInfo.plant_short_code;
  const loggedInDepotId = userD?.result?.userInfo?.depot_id;
  const loggedInPlantId = userD?.result?.userInfo?.plant_id;
  const plant_id = userInfo.plant_id;
  const { handleSubmit } = useForm();
  const urlLocation = useLocation();
  const editInfo = urlLocation.state;
  const editData = editInfo && editInfo;
  const editid = editData ? editData.inward_id : null;
  let navigate = useNavigate();

  const [table_details, setTable_Details] = useState(
    editData ? JSON.parse(editData.table_details) : [{ srno: "", cyl_no: "", tag_no: "", owner: "", reason: "", state: "" }]
  );

  const [data, setData] = useState({
    from_location: editData ? editData.from_location : "customer",
    from_depot_id: editData ? editData.from_depot_id : "",
    option: editData ? editData.option : "",
    to_location: editData ? editData.to_location : "",
    to_depot_id: editData ? editData.to_depot_id : "",
    driver_id: editData ? editData.driver_id : "",
    vehicle_id: editData ? editData.vehicle_id : "",
    entry_date: editData?.entry_date ? dayjs(editData.entry_date).format("DD/MM/YYYY") : dayjs().format("DD/MM/YYYY"),
    entry_no: editData ? editData.entry_no : "",
    customer: editData ? editData.customer : "",
    from_customer_id: editData ? editData.from_customer_id : "",
    fin_year: editData ? editData.fin_year : dayjs().month() >= 3 ? `${dayjs().year()}-${dayjs().year() + 1}` : `${dayjs().year() - 1}-${dayjs().year()}`,
    challan_no: editData ? editData.challan_no : "",
    challan_date: editData ? editData.challan_date || "" : "",
    empty_challan_no: editData ? editData.empty_challan_no : "",
    plant: editData ? editData.plant : "",
    to_plant_id: editData ? editData.to_plant_id : null,
    challan_type: editData ? editData.challan_type : "customer",
    sales_return: "",
     prod_code: editData ? editData.prod_code || "DA001" : "DA001",
      prod_id: editData ? editData.prod_id || null : null,
  });

  const [filteredCylinders, setFilteredCylinders] = useState([]);
  const [confirmModal, setConfirmModal] = useState({ open: false, index: null, checked: false, cylinder_no: "" });
  const [driver, setDriver] = useState([]);
  const [depot, setDepot] = useState([]);
  const [product, setProduct] = useState([]);
  const [vehicle, setVehicle] = useState([]);
  const [cylinder, setCylinder] = useState([]);
  const [customer, setCustomer] = useState([]);
  const [plant, setPlant] = useState([]);
  const [customerecr, setCustomerecr] = useState([]);
  const [customerECRCylinders, setCustomerECRCylinders] = useState([]);
  const [dcNoData, setDcNoData] = useState([]);
  const [emptyNoData, setEmptyNoData] = useState([]);
  const [challanCylinders, setChallanCylinders] = useState([]);
  const [cylinder_inward, setCylinderInward] = useState([]);
  const [successMessage, setSuccessMessage] = useState(null);
  const [isScannerOpen, setIsScannerOpen] = useState(false);
  const [scanResults, setScanResults] = useState([]);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const qrCodeRegionId = 'qr-reader';
  const html5QrCodeRef = useRef(null);
  const scannerStateRef = useRef({ isStarting: false, isStopping: false });
  const lastScanTimeRef = useRef(0);
  const debounceDelay = 500;
  const [tagMap, setTagMap] = useState({});
  const [openDialog, setOpenDialog] = useState(false);
  const [isMultiDialog, setIsMultiDialog] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [supplier, setSupplier] = useState([]);
  const [sales, setSales] = useState([]);
  const [selectedFromDepotId, setSelectedFromDepotId] = useState(null);
  const [isLoadingChallan, setIsLoadingChallan] = useState(false);
 const [dialogData, setDialogData] = useState({ cyl_no: '', cyl_id: '', owner: '', tag_no: '', state: 'Empty', level: '', note: '', reason: 'OK', qty: 1, uom: 'CUM', status: 'Empty', customer_id: null, customer_name: null });
  const [multiDialogData, setMultiDialogData] = useState({ cyl_nos: '' });
 const [editIndex, setEditIndex] = useState(null);
 const handleAddSupplierRow = () => {
    setFilteredCylinders(prev => [...prev, {
      cyl_id: null, cyl_no: "", tag_no: "", owner: "TGPL",
      status: "Empty", checked: false, qty: 1, uom: "NOS", remark: ""
    }]);
  };

  const handleRemoveSupplierRow = (index) => {
    setFilteredCylinders(prev => prev.filter((_, i) => i !== index));
  };

  const handleChangeSupplierRow = (e, index) => {
    const { name, value } = e.target;
    setFilteredCylinders(prev => {
      const updated = [...prev];
      updated[index] = { ...updated[index], [name]: value };
      return updated;
    });
  };

// 👇 yahan rakho — component ke top level pe, kisi function ke andar nahi
const availableCylinders = React.useMemo(
  () => cylinder.filter(
    (c) => !filteredCylinders.some((row) => row.cyl_no === c.cylinder_no)
  ),
  [cylinder, filteredCylinders]
);

  useEffect(() => {
    async function fetchData() {
      try {
        const [customerData, driverData, depotData, productData, cylinderData, vehicleData, plantData, deliveryData, emptychallanData, DepotCustomerData, DcNoData, EmptyNoData, RelatedDepotData, supplierData, salesData,  inwardListData ] = await Promise.all([
          customerMasterService.getCustomerList({ page: 0, size: 999, searchKey: '' }),
          driverMasterService.getDriverList({ page: 0, size: 999, searchKey: '' }),
          depotMasterService.getDepotList({ page: 0, size: 999, searchKey: '' }),
          productMasterService.getProductList({ page: 0, size: 999, searchKey: '' }),
          cylinderMasterService.getCylinderList({ page: 0, size: 999, searchKey: '' }),
          vehicleMasterService.getVehicleList({ page: 0, size: 999, searchKey: '' }),
          plantMasterService.getPlantList({ page: 0, size: 999, searchKey: '' }),
          DeliveryChallanService.getDeliveryChallanList({ page: 0, size: 999, searchKey: '', depot_id: loggedInDepotId }),
          emptycallanservice.getEmptyDeliverychallanList({ page: 0, size: 999, searchKey: '', depot_id: selectedFromDepotId }),
          inwardService.getInwardCustomerList(depot_id),
          inwardService.getCustomerDCno(depot_id),
          inwardService.getCustomerEmptyno(depot_id),
          inwardService.getInwardRealteddepotList(depot_id),
          supplierMasterService.getSupplierList({ page: 0, size: 999, searchKey: '' }),
          editData && editData.from_customer_id && editData.option === 'sales_return'
            ? salesreturnServices.getsalesreturnchallanlist({ cust_id: editData.from_customer_id, page: 0, size: 999, searchKey: '' })
            : Promise.resolve([]),
              inwardService.getCylinderInwardList({ page: 0, size: 5, searchKey: '' }),
        ]);

        const normalizedVehicleData = vehicleData.map(v => ({ ...v, vehicle_id: String(v.vehicle_id) }));
        const normalizedDriverData = driverData.map(d => ({ ...d, driver_id: String(d.driver_id) }));
        const driverIdMap = {};
        normalizedDriverData.forEach(d => { driverIdMap[d.driver_id] = d; });
        const uniqueDriverData = Object.values(driverIdMap);

        setCustomer(DepotCustomerData);
        setDriver(uniqueDriverData);
        setDepot(RelatedDepotData);
        setProduct(productData);
        setCylinder(cylinderData);
        setVehicle(normalizedVehicleData);
        setPlant(plantData);
        setDcNoData(DcNoData);
        setEmptyNoData(EmptyNoData);
        setCylinderInward(deliveryData);
        if (!editData) {
  const lastEntryNo = inwardListData?.[0]?.entry_no ?? "";
  console.log("lastEntryNo =>", lastEntryNo); // verify karo

  const parts = String(lastEntryNo).split("/");
  const lastSeq = parseInt(parts[parts.length - 1]) || 0;
  const nextSeq = lastSeq + 1;

  // Already-added cylinders ko dropdown se hata do


  const yr = dayjs();
  const finYear = yr.month() >= 3
    ? `${String(yr.year()).slice(-2)}-${String(yr.year() + 1).slice(-2)}`
    : `${String(yr.year() - 1).slice(-2)}-${String(yr.year()).slice(-2)}`;

  const formattedEntryNo = `IN/${short_code}/${finYear}/${String(nextSeq).padStart(4, "0")}`;

  setData(prev => ({
    ...prev,
    entry_no: formattedEntryNo,
    fin_year: finYear,
  }));
}
        setSupplier(supplierData || []);
        setSales(salesData || []);
      } catch (error) {
        console.error('Error fetching data:', error.message);
      }
    }
    fetchData();
  }, [depot_id, loggedInDepotId, editData]);

  useEffect(() => {
    if (editData && editData.table_details) {
      try {
        const parsed = JSON.parse(editData.table_details).map((row) => ({ ...row, checked: false, qty: parseFloat(row.qty) || 1 }));
        setFilteredCylinders(parsed);
      } catch (e) { setFilteredCylinders([]); }
    }
  }, [editData]);

  const handleChange = async ({ target }) => {
    const { name, value } = target;

    if (name === "entry_date") {
      let formattedDate = value instanceof Date ? (dayjs(value).isValid() ? dayjs(value).format("DD/MM/YYYY") : "") : typeof value === "string" ? value : "";
      const financialYear = formattedDate ? dayjs(formattedDate, "DD/MM/YYYY").month() >= 3 ? `${dayjs(formattedDate, "DD/MM/YYYY").year()}-${dayjs(formattedDate, "DD/MM/YYYY").year() + 1}` : `${dayjs(formattedDate, "DD/MM/YYYY").year() - 1}-${dayjs(formattedDate, "DD/MM/YYYY").year()}` : "";
      setData(prev => ({ ...prev, entry_date: formattedDate, fin_year: financialYear }));
      return;
    }

   if (name === "from_location") {
      const isCustomer = value === "customer", isDepot = value === "depot";
      const isSupplier = value === "supplier";
      setData(prev => ({ ...prev, from_location: value, customer: isCustomer ? prev.customer : "", from_customer_id: isCustomer ? prev.from_customer_id : "", from_depot_id: isDepot ? prev.from_depot_id : "", option: isCustomer ? (prev.option || "challan_no") : "delivery_challan", challan_no: "", challan_date: "", empty_challan_no: "", vehicle_no: "", vehicle_id: "", driver_name: "", driver_id: "", sales_return: "" }));
      if (isSupplier) {
        setFilteredCylinders([{ cyl_id: null, cyl_no: "", tag_no: "", owner: "TGPL", status: "Empty", checked: false, qty: 1, uom: "NOS", remark: "" }]);
      } else if (!isCustomer) {
        setCustomerecr([]); setCustomerECRCylinders([]); setSales([]); setFilteredCylinders([]);
      }
      return;
    }

   if (name === "depot") {
      const depId = value ? Number(value) : null;
      setSelectedFromDepotId(depId);
      setData(prev => ({ ...prev, from_depot_id: value || "", from_depot_name: depot.find(d => d.depot_id === depId)?.depot_name || "", empty_challan_no: "", challan_no: "", challan_date: "", vehicle_no: "", vehicle_id: "", driver_name: "", driver_id: "" }));
      setFilteredCylinders([]); setChallanCylinders([]);
      if (depId) {
        inwardService.getCustomerEmptyno(depot_id, depId)
          .then((res) => setEmptyNoData(Array.isArray(res) ? res : []))
          .catch(() => setEmptyNoData([]));
      } else {
        setEmptyNoData([]);
      }
      return;
    }

    if (name === "customer") {
      const selectedCustomer = customer.find(c => c.cust_id === value);
      setData(prev => ({ ...prev, from_location: "customer", customer: selectedCustomer?.cust_name || "", from_customer_id: value, challan_no: "", challan_date: "", sales_return: "", challan_type: "customer", vehicle_no: "", vehicle_id: "", driver_name: "", driver_id: "", option: "challan_no" }));
      setCustomerecr([]); setCustomerECRCylinders([]); setSales([]); setFilteredCylinders([]);
      if (value) {
        try {
          const ecrs = await inwardService.getCustomerECR(value);
          setCustomerecr(ecrs || []);
          if (data.option === "sales_return") {
            const salesReturnData = await salesreturnServices.getsalesreturnchallanlist({ cust_id: value, page: 0, size: 999, searchKey: "" });
            setSales(salesReturnData || []);
          }
        } catch (error) { console.error("Error fetching customer data:", error.message); }
      }
      return;
    }

    if (name === "option") {
      setData(prev => ({ ...prev, option: value, challan_no: "", challan_date: "", sales_return: "", vehicle_no: "", vehicle_id: "", driver_name: "", driver_id: "" }));
      if (value === "sales_return" && data.from_customer_id) {
        try {
          const salesReturnData = await salesreturnServices.getsalesreturnchallanlist({ cust_id: data.from_customer_id, page: 0, size: 999, searchKey: "" });
          setSales(salesReturnData || []);
        } catch (error) { console.error("Error fetching sales return data:", error.message); }
      } else { setSales([]); setFilteredCylinders([]); setTable_Details([]); }
      return;
    }

    if (name === "challan_no" && data.option === "delivery_challan") {
      const selectedChallanNo = value.trim();
      setData(prev => ({ ...prev, challan_no: selectedChallanNo, vehicle_no: "", driver_name: "" }));
      if (!selectedChallanNo) { setFilteredCylinders([]); return; }
      setIsLoadingChallan(true);
      try {
        const cylinderData = await inwardService.getChallanCylinderDetails(selectedChallanNo, data.option);
        const rows = (Array.isArray(cylinderData) ? cylinderData : []).map(c => ({ cyl_id: c.cyl_id, cyl_no: c.cyl_no || c.cylinder_no || "", tag_no: c.tag_no || "", owner: c.owner || "TGPL", status: c.status, checked: false, qty: Number(c.qty) || 1, uom: c.uom || "NOS" }));
        setFilteredCylinders(rows);
        const firstRow = Array.isArray(cylinderData) ? cylinderData[0] : null;
        if (firstRow) setData(prev => ({ ...prev, vehicle_no: firstRow.vehicle_no || "", driver_name: firstRow.driver_name || "" }));
        if (rows.length === 0) { setSuccessMessage("This challan has no cylinders"); setOpenSnackbar(true); }
      } catch (err) { setSuccessMessage(err.response?.data?.message || "Could not load cylinders"); setOpenSnackbar(true); setFilteredCylinders([]); }
      finally { setIsLoadingChallan(false); }
    }
// ✅ After
if (name === "empty_challan_no") {
  setData(prev => ({ ...prev, empty_challan_no: value, challan_no: value, vehicle_no: "", vehicle_id: "", driver_name: "", driver_id: "" }));
  if (!value) { setFilteredCylinders([]); return; }
  setIsLoadingChallan(true);
  try {
    const cylinderData = await inwardService.getChallanCylinderDetails(value, "empty_challan");
 const rows = (Array.isArray(cylinderData) ? cylinderData : []).map(c => ({
      cyl_id: c.cyl_id, cyl_no: c.cyl_no || c.cylinder_no || "",
      tag_no: c.tag_no || "", owner: c.owner || "TGPL",
      status: c.status, checked: false,
      qty: Number(c.qty) || 1, uom: c.uom || "NOS",
      remark: c.remark || c.note || "",
      prod_code: c.prod_code || ""
    }));
    setFilteredCylinders(rows);
    const firstRow = Array.isArray(cylinderData) ? cylinderData[0] : null;
    if (firstRow) {
      setData(prev => ({
        ...prev,
        vehicle_no: firstRow.vehicle_no || "",
        driver_name: firstRow.driver_name || "",
        prod_code: firstRow.prod_code || prev.prod_code || "DA001",
        prod_id: firstRow.prod_id || prev.prod_id || null,
      }));
    }
    if (rows.length === 0) { setSuccessMessage("This challan has no cylinders"); setOpenSnackbar(true); }
  } catch (err) {
    setSuccessMessage("Could not load cylinders"); setOpenSnackbar(true); setFilteredCylinders([]);
  } finally { setIsLoadingChallan(false); }
  return;
}

if (name === "challan_no" && data.from_location === "customer" && data.option === "challan_no") {
  const selectedEcrNo = value.trim();
  setData(prev => ({ ...prev, challan_no: selectedEcrNo, vehicle_no: "", driver_name: "", challan_date: "" }));
  if (!selectedEcrNo) { setFilteredCylinders([]); return; }
  setIsLoadingChallan(true);
  try {
    const ecrCylinderData = await inwardService.getCustomerECRCylinder(selectedEcrNo, data.from_customer_id);
    const rows = (Array.isArray(ecrCylinderData) ? ecrCylinderData : []).map(c => ({ cyl_id: c.cyl_id, cyl_no: c.cyl_no || c.cylinder_no || "", tag_no: c.tag_no || "", owner: c.owner || "TGPL", status: c.status || "Empty", checked: false, qty: Number(c.qty) || 1, uom: c.uom || "CUM", customer_id: c.customer_id || data.from_customer_id, customer_name: c.customer_name || data.customer, remark: c.remark || c.note || "", prod_code: c.prod_code || "" }));
    setFilteredCylinders(rows);
    const firstRecord = Array.isArray(ecrCylinderData) && ecrCylinderData[0] ? ecrCylinderData[0] : null;
    if (firstRecord) setData(prev => ({
      ...prev,
      vehicle_no: firstRecord.vehicle_no || firstRecord.vehicle_number || "",
      driver_name: firstRecord.driver_name || firstRecord.driver || "",
      challan_date: firstRecord.challan_date || firstRecord.entry_date || "",
      prod_code: firstRecord.prod_code || prev.prod_code || "DA001",
      prod_id: firstRecord.prod_id || prev.prod_id || null,
    }));
    if (rows.length === 0) { setSuccessMessage("No cylinders found in this ECR"); setOpenSnackbar(true); }
  } catch (err) { setSuccessMessage("Failed to load ECR cylinders"); setOpenSnackbar(true); setFilteredCylinders([]); }
  finally { setIsLoadingChallan(false); }
}
    setData(prev => ({ ...prev, [name]: value }));
  };

  const handleCheckClick = (index) => {
    const cyl = filteredCylinders[index];
    setConfirmModal({ open: true, index, checked: !cyl.checked, cylinder_no: cyl.cyl_no });
  };

  const handleConfirmCheck = (confirm) => {
    if (confirm && confirmModal.index !== null) {
      setFilteredCylinders(prev => prev.map((row, idx) => idx === confirmModal.index ? { ...row, checked: confirmModal.checked } : row));
    }
    setConfirmModal({ open: false, index: null, checked: false, cylinder_no: "" });
  };

  const handleQtyChange = (index, value) => {
    const parsedValue = parseFloat(value);
    setFilteredCylinders(prev => prev.map((row, idx) => idx === index ? { ...row, qty: isNaN(parsedValue) || parsedValue < 0 ? 1 : parsedValue } : row));
  };

  const handlePrint = () => {
    const printWindow = window.open('', '_blank');
    printWindow.document.write(`<html><head><title>Cylinder Inward</title><style>body{font-family:Arial,sans-serif;margin:20px}table{width:100%;border-collapse:collapse}th,td{border:1px solid #ddd;padding:8px}th{background:#f2f2f2}h2{text-align:center}</style></head><body><h2>Cylinder Inward Table</h2><table><thead><tr><th>Sr No</th><th>Cylinder No</th><th>Tag No</th><th>Owner</th><th>Status</th>${data.option === "delivery_challan" ? '<th>Qty</th>' : ''}<th>UOM</th><th>Check</th></tr></thead><tbody>${filteredCylinders.map((row, index) => `<tr><td>${index + 1}</td><td>${row.cyl_no || ""}</td><td>${row.tag_no}</td><td>${row.owner === 'TGPL' ? 'TGPL' : row.customer_name || row.owner}</td><td>${row.status}</td>${data.option === "delivery_challan" ? `<td>${row.qty}</td>` : ''}<td>${row.uom}</td><td>${row.checked ? '✔' : ''}</td></tr>`).join('')}</tbody></table></body></html>`);
    printWindow.document.close();
    printWindow.print();
    printWindow.close();
  };

  const moveFromOptions = [{ label: 'Customer', value: 'customer' }, { label: 'Depot', value: 'depot' }, { label: 'Supplier', value: 'supplier' }];
  const customerOptions = customer || [];
  const depotOptions = depot || [];
  const supplierOptions = supplier || [];

const [isSubmitting, setIsSubmitting] = useState(false);

  const onSubmit = async () => {
    if (isSubmitting) return;
    const isSupplierFlow = data.from_location === "supplier";
    if (isSupplierFlow) {
      const hasEmptyCylNo = filteredCylinders.some(row => !row.cyl_no || !row.cyl_no.toString().trim());
      if (hasEmptyCylNo) { setSuccessMessage("Please enter cylinder no for all rows before saving."); setOpenSnackbar(true); return; }
    } else {
      const allChecked = filteredCylinders.every(row => row.checked);
      if (!allChecked) { setSuccessMessage("Please check all cylinders before saving."); setOpenSnackbar(true); return; }
    }
   const td = filteredCylinders.map((row, idx) => ({ srno: idx + 1, cyl_id: row.cyl_id, cyl_no: row.cyl_no || "", tag_no: row.tag_no, owner: row.owner, customer_id: row.customer_id, checked: isSupplierFlow ? true : row.checked, qty: row.qty, uom: row.uom, status: row.status, level: row.level ?? row.note ?? '', note: row.level ?? row.note ?? '', remark: row.remark || "", prod_id: row.prod_id || data.prod_id || null, prod_code: row.prod_code || data.prod_code || "DA001" }));
  if (!data || td.length === 0) { setSuccessMessage("Error occurred: Please fill fields"); setOpenSnackbar(true); return; }
    setIsSubmitting(true);
    const inward_Data = { ...data, to_location: data.to_location, to_depot_id: data.to_depot_id || "", to_plant_id: data.to_depot_id ? null : plant_id, inward_id: editid, table_details: JSON.stringify(td), challan_no: isSupplierFlow ? (data.supplier_challan_no || "") : data.challan_no, challan_date: data.challan_date || new Date().toISOString().split('T')[0], modified_at: dayjs().format("YYYY-MM-DD HH:mm:ss"), modified_by: editData ? userInfo.user_id : null, created_at: dayjs().format("YYYY-MM-DD HH:mm:ss"), created_by: editData ? editData.created_by : userInfo.user_id, changedUpdatedValue: "edit", unit_id, short_code, challan_type: data.challan_type, from_supplier_id: isSupplierFlow ? (data.supplier || "") : (data.from_supplier_id || "") };
    try {
      if (editData) await inwardService.editDeleteCylinderInward(inward_Data);
      else await inwardService.addCylinderInward(inward_Data);
      setSuccessMessage(editData ? "Updated successfully" : "Added successfully");
      setTimeout(() => navigate(-1), 1000);
     } catch (error) { console.error("Error during submission:", error.message); setSuccessMessage("Error occurred during submission"); setOpenSnackbar(true); setIsSubmitting(false); }
  };

  useEffect(() => {
    if (isScannerOpen && openDialog) {
      const init = async () => {
        if (scannerStateRef.current.isStarting) return;
        scannerStateRef.current.isStarting = true;
        try {
          html5QrCodeRef.current = new Html5Qrcode(qrCodeRegionId);
          await html5QrCodeRef.current.start({ facingMode: 'environment' }, { fps: 10, qrbox: { width: 250, height: 250 } }, handleScannedCode, () => {});
        } catch (err) { setSuccessMessage('Failed to start QR scanner.'); setOpenSnackbar(true); setIsScannerOpen(false); }
        finally { scannerStateRef.current.isStarting = false; }
      };
      init();
    }
    return () => {
      if (html5QrCodeRef.current?.isScanning && !scannerStateRef.current.isStopping) {
        scannerStateRef.current.isStopping = true;
        html5QrCodeRef.current.stop().then(() => { html5QrCodeRef.current.clear(); scannerStateRef.current.isStopping = false; }).catch(() => { scannerStateRef.current.isStopping = false; });
      }
    };
  }, [isScannerOpen, openDialog]);

  const handleScannedCode = (decodedText) => {
    const now = Date.now();
    if (now - lastScanTimeRef.current < debounceDelay) return;
    lastScanTimeRef.current = now;
    if (scanResults.includes(decodedText)) { setSuccessMessage(`QR code (${decodedText}) already scanned`); setOpenSnackbar(true); return; }
    const mappedCylinder = cylinder.find(map => map.tag_no === decodedText || map.cylinder_no === decodedText);
    if (!mappedCylinder) { setSuccessMessage(`Scanned code ${decodedText} not found`); setOpenSnackbar(true); return; }
    const cylinderNoToUse = mappedCylinder.cylinder_no;
    const cylinderIndex = filteredCylinders.findIndex(row => row.cyl_no === cylinderNoToUse || row.cyl_id === mappedCylinder.cyl_id);
    if (cylinderIndex !== -1) { setFilteredCylinders(prev => prev.map((row, idx) => idx === cylinderIndex ? { ...row, checked: true } : row)); setSuccessMessage(`Cylinder ${cylinderNoToUse} auto-checked.`); setOpenSnackbar(true); setScanResults(prev => [...prev, decodedText]); return; }
    if (isMultiDialog) { setMultiDialogData(prev => ({ cyl_nos: prev.cyl_nos ? `${prev.cyl_nos}, ${cylinderNoToUse}` : cylinderNoToUse })); setScanResults(prev => [...prev, decodedText]); }
    else { setDialogData({ cyl_no: mappedCylinder.cylinder_no, cyl_id: mappedCylinder.cyl_id, owner: mappedCylinder.owner, tag_no: mappedCylinder.tag_no, note: mappedCylinder.note, state: 'Empty', reason: 'OK', qty: parseFloat(mappedCylinder.qty) || 1, uom: mappedCylinder.uom || 'CUM', status: mappedCylinder.status || 'Empty', customer_id: mappedCylinder.customer_id || null, customer_name: mappedCylinder.cust_name || null }); setScanResults(prev => [...prev, decodedText]); }
  };

  const startScanner = async () => setIsScannerOpen(true);
  const stopScanner = async () => {
    if (html5QrCodeRef.current?.isScanning && !scannerStateRef.current.isStopping) {
      scannerStateRef.current.isStopping = true;
      try { await html5QrCodeRef.current.stop(); html5QrCodeRef.current.clear(); setIsScannerOpen(false); } catch (err) {} finally { scannerStateRef.current.isStopping = false; }
    }
  };

  const handleOpenDialog = async () => { await stopScanner();setDialogData({ cyl_no: '', cyl_id: '', owner: '', tag_no: '', level: '', note: '', state: '', reason: 'OK', qty: 1, uom: 'CUM', status: '', customer_id: null, customer_name: null });setEditIndex(null); setIsMultiDialog(false); setOpenDialog(true); setScanResults([]); };
  const handleOpenmulDialog = async () => { await stopScanner(); setMultiDialogData({ cyl_nos: '' }); setEditIndex(null); setIsMultiDialog(true); setOpenDialog(true); setScanResults([]); setIsScannerOpen(true); };
  const handleDialogChange = (e) => { const { name, value } = e.target; if (isMultiDialog) setMultiDialogData(prev => ({ ...prev, [name]: value })); else setDialogData(prev => ({ ...prev, [name]: value })); };
 const handleMultiDialogChange = ({ target }) => setMultiDialogData({ cyl_nos: target.value });
const handleCloseDialog = () => { stopScanner(); setOpenDialog(false); setScanResults([]); setMultiDialogData({ cyl_nos: '' }); };
 

  const handleDialogSubmit = async () => {
    try {
      if (isMultiDialog) {
        const cylNos = [...new Set(multiDialogData.cyl_nos.split(',').map(no => no.trim()).filter(no => no && cylinder.some(cyl => cyl.cylinder_no === no)))];
        if (!cylNos.length) { setSuccessMessage('Please enter at least one valid cylinder number'); setOpenSnackbar(true); return; }
        const newRows = [];
        for (const cyl_no of cylNos) {
          const sc = cylinder.find(cyl => cyl.cylinder_no === cyl_no);
          if (!sc) continue;
          const ci = filteredCylinders.findIndex(row => row.cyl_id === sc.cyl_id);
          if (ci !== -1) { setFilteredCylinders(prev => prev.map((row, idx) => idx === ci ? { ...row, checked: true } : row)); continue; }
          newRows.push({ cyl_no: sc.cylinder_no, cyl_id: sc.cyl_id, tag_no: sc.tag_no, owner: sc.owner, level: sc.level ?? sc.note ?? '', note: sc.level ?? sc.note ?? '', state: 'Empty', reason: 'OK', qty: parseFloat(sc.qty) || 1, checked: false, uom: sc.uom || 'CUM', status: sc.status || 'Empty', customer_id: sc.customer_id || null, customer_name: sc.cust_name || null });
        }
        if (newRows.length > 0) { setFilteredCylinders(prev => [...prev, ...newRows]); setTable_Details(prev => [...prev, ...newRows.map((row, index) => ({ srno: prev.length + index + 1, cyl_no: row.cyl_no, tag_no: row.tag_no, owner: row.owner, state: row.state, note: row.note, reason: row.reason, qty: row.qty }))]); }
      } else {
        if (!dialogData.cyl_no) { setSuccessMessage('Please select or scan a cylinder number'); setOpenSnackbar(true); return; }
        const sc = cylinder.find(cyl => cyl.cylinder_no === dialogData.cyl_no);
        if (!sc) { setSuccessMessage(`Cylinder ${dialogData.cyl_no} not found`); setOpenSnackbar(true); return; }
        const ci = filteredCylinders.findIndex(row => row.cyl_id === sc.cyl_id);
        if (ci !== -1 && ci !== editIndex) { setFilteredCylinders(prev => prev.map((row, idx) => idx === ci ? { ...row, checked: true } : row)); setSuccessMessage(`Cylinder ${dialogData.cyl_no} already added and auto-checked`); setOpenSnackbar(true); return; }
        const upd = { cyl_no: sc.cylinder_no, cyl_id: sc.cyl_id, tag_no: sc.tag_no, owner: sc.owner, state: dialogData.state, level: dialogData.level ?? dialogData.note ?? '', note: dialogData.level ?? dialogData.note ?? '', reason: dialogData.reason, qty: parseFloat(sc.qty) || dialogData.qty || 1, checked: false, uom: sc.uom || 'CUM', status: sc.status || 'Empty', customer_id: sc.customer_id || null, customer_name: sc.cust_name || null };
        setFilteredCylinders(prev => { if (editIndex !== null) { const u = [...prev]; u[editIndex] = upd; return u; } return [...prev, upd]; });
        setTable_Details(prev => { if (editIndex !== null) { const u = [...prev]; u[editIndex] = { srno: editIndex + 1, cyl_no: upd.cyl_no, tag_no: upd.tag_no, owner: upd.owner, state: upd.state, reason: upd.reason, qty: upd.qty, note: upd.note }; return u; } return [...prev, { srno: prev.length + 1, cyl_no: upd.cyl_no, tag_no: upd.tag_no, owner: upd.owner, state: upd.state, reason: upd.reason, qty: upd.qty, note: upd.note }]; });
      }
      await stopScanner(); setOpenDialog(false); setSuccessMessage(isMultiDialog ? 'Multiple cylinders added' : 'Cylinder added'); setOpenSnackbar(true);
    } catch (error) { setSuccessMessage('Error adding cylinder'); setOpenSnackbar(true); }
  };

  const acInput = (params, placeholder = "", readonly = false) => (
    <TextField
      {...params}
      size="small"
      fullWidth
      placeholder={placeholder}
      sx={readonly ? readonlyInputSx : inputSx}
      InputProps={{
        ...params.InputProps,
        readOnly: readonly,
        endAdornment: readonly ? null : params.InputProps?.endAdornment,
        style: readonly ? { backgroundColor: "#F0F4F8" } : {},
      }}
    />
  );

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box sx={pageSx}>
        {/* Breadcrumb */}
        <Box sx={breadcrumbSx}>
          <span>Dashboard</span> / <span style={{ color: "#2B6CB0", fontWeight: 600 }}>Cylinder Inward</span>
        </Box>

        {/* Page Header */}
        <Box sx={pageHeaderSx}>
          <Box sx={pageTitleSx}>
            <MoveToInboxIcon sx={{ fontSize: 20, color: "#1C3A5E" }} />
            {editData ? "UPDATE" : "ADD"} CYLINDER INWARD
          </Box>
          <Button onClick={() => navigate(-1)} sx={backBtnSx}>
            <ArrowBackIcon sx={{ fontSize: 16 }} /> Back
          </Button>
        </Box>

        {/* Last Entry Info */}
        {!editData && cylinder_inward && (
          <Box sx={{ fontSize: "12px", color: "#718096", textAlign: "right", mb: 1.5 }}>
            Last Entry No : {cylinder_inward.length > 0 ? cylinder_inward[0].lastInwardEntryNo : "0"}
          </Box>
        )}

        <form onSubmit={handleSubmit(onSubmit)}>

          {/* ── Cylinder Inward Details Card ─────────────────────────── */}
          <Box sx={formCardSx}>
            <Box sx={sectionHeaderSx}>
              <MoveToInboxIcon sx={{ fontSize: 18, color: "#fff" }} />
              <Typography sx={sectionHeaderTitleSx}>CYLINDER INWARD DETAILS</Typography>
            </Box>

            <Box sx={formBodySx}>
              {/* ── Two-column container matching Production Entry layout ── */}
              <Grid container sx={{ border: "1px solid #E2E8F0", borderRadius: "10px", overflow: "hidden" }}>

                {/* ════════ LEFT COLUMN — Source & Challan Info ════════ */}
                <Grid
                  item xs={12} md={6}
                  sx={{
                    p: 2.5,
                    
                    borderBottom: { xs: "2px dashed #CBD5E0", md: "none" },
                  }}
                >
                  <Grid container spacing={1.5}>

                    {/* From Location */}
                    <Grid item xs={7} sm={5}>
                      <Typography sx={fieldLabelSx}>From Location</Typography>
                      <Autocomplete
                        disablePortal fullWidth options={moveFromOptions} clearIcon={false}
                        getOptionLabel={o => typeof o === 'string' ? o : o.label}
                        value={moveFromOptions.find(o => o.value === data.from_location) || null}
                        onChange={(e, nv) => handleChange({ target: { name: 'from_location', value: nv ? nv.value : '' } })}
                        isOptionEqualToValue={(o, v) => o.value === v.value}
                        renderOption={(props, option) => <MenuItem {...props} sx={menuItemSx}>{option.label}</MenuItem>}
                        renderInput={(params) => acInput(params, "Select location")}
                      />
                    </Grid>

                    {/* Customer — shown when from_location === "customer" */}
                    {data.from_location === "customer" && (
                      <Grid item xs={7} sm={7}>
                        <Typography sx={fieldLabelSx}>Customer</Typography>
                        <Autocomplete
                          disablePortal fullWidth options={customerOptions} clearIcon={false}
                          getOptionLabel={o => typeof o === 'string' ? o : o.cust_name || ''}
                          value={customerOptions.find(c => c.cust_id === data.from_customer_id) || null}
                          onChange={(e, nv) => handleChange({ target: { name: 'customer', value: nv ? nv.cust_id : '' } })}
                          isOptionEqualToValue={(o, v) => o.cust_id === v.cust_id}
                          renderOption={(props, option) => <MenuItem {...props} sx={menuItemSx}>{option.cust_name}</MenuItem>}
                          renderInput={(params) => acInput(params, "Select customer")}
                        />
                      </Grid>
                    )}

                    {/* Depot — shown when from_location === "depot" */}
                    {data.from_location === "depot" && (
                      <Grid item xs={7} sm={7}>
                        <Typography sx={fieldLabelSx}>Depot</Typography>
                        <Autocomplete
                          disablePortal fullWidth
                          options={depotOptions.filter(d => d.depot_id !== Number(loggedInDepotId))}
                          clearIcon={false}
                          getOptionLabel={o => typeof o === 'string' ? o : o.depot_name || ''}
                          value={depotOptions.find(d => d.depot_id === data.from_depot_id) || null}
                          onChange={(e, nv) => handleChange({ target: { name: 'depot', value: nv ? nv.depot_id : '' } })}
                          isOptionEqualToValue={(o, v) => o.depot_id === v.depot_id}
                          renderOption={(props, option) => <MenuItem {...props} sx={menuItemSx}>{option.depot_name}</MenuItem>}
                          renderInput={(params) => acInput(params, "Select depot")}
                        />
                      </Grid>
                    )}

                    {/* Supplier — shown when from_location === "supplier" */}
                    {data.from_location === "supplier" && (
                      <Grid item xs={7} sm={7}>
                        <Typography sx={fieldLabelSx}>Supplier</Typography>
                        <Autocomplete
                          disablePortal fullWidth options={supplierOptions} clearIcon={false}
                          getOptionLabel={o => typeof o === 'string' ? o : o.supplier_name || ''}
                          value={supplierOptions.find(c => c.supplier_id === data.supplier) || null}
                          onChange={(e, nv) => handleChange({ target: { name: 'supplier', value: nv ? nv.supplier_id : '' } })}
                          isOptionEqualToValue={(o, v) => o.supplier_id === v.supplier_id}
                          renderOption={(props, option) => <MenuItem {...props} sx={menuItemSx}>{option.supplier_name}</MenuItem>}
                          renderInput={(params) => acInput(params, "Select supplier")}
                        />
                      </Grid>
                    )}

                    {/* Option Radio — Customer */}
                    {data.from_location === "customer" && (
                      <Grid item xs={7} sm={5}>
                        <Typography sx={fieldLabelSx}>Choose an Option</Typography>
                        <Box sx={{ display: "flex", alignItems: "center", height: "36px", gap: 1 }}>
                          <RadioGroup row name="option" value={data.option || "challan_no"} onChange={handleChange}>
                            <FormControlLabel
                              value="challan_no"
                              control={<Radio size="small" sx={{ color: "#2063b6", '&.Mui-checked': { color: "#2063b6" } }} />}
                              label={<Typography sx={{ fontSize: "13px", color: "#2D3748" }}>ECR No</Typography>}
                            />
                          </RadioGroup>
                        </Box>
                      </Grid>
                    )}

                    {/* Option Radio — Depot */}
                    {data.from_location === "depot" && (
                      <Grid item xs={7} sm={10}>
                        <Typography sx={fieldLabelSx}>Choose an Option</Typography>
                        <Box sx={{ display: "flex", alignItems: "center", height: "36px" }}>
                          <RadioGroup row name="option" value={data.option || "delivery_challan"} onChange={handleChange}>
                            <FormControlLabel
                              value="delivery_challan"
                              control={<Radio size="small" sx={{ color: "#2063b6", '&.Mui-checked': { color: "#2063b6" } }} />}
                              label={<Typography sx={{ fontSize: "13px" }}>Delivery Challan</Typography>}
                            />
                            <FormControlLabel
                              value="empty_challan"
                              control={<Radio size="small" sx={{ color: "#2063b6", '&.Mui-checked': { color: "#2063b6" } }} />}
                              label={<Typography sx={{ fontSize: "13px" }}>Empty Challan</Typography>}
                            />
                          </RadioGroup>
                        </Box>
                      </Grid>
                    )}

                    {/* ECR No */}
                    {data.from_location === "customer" && data.option === "challan_no" && (
                      <Grid item xs={7} sm={10}>
                        <Typography sx={fieldLabelSx}>ECR No</Typography>
                        <Box sx={{ display: "flex", gap: 1 }}>
                      <Autocomplete
  disablePortal
  fullWidth
  componentsProps={{
    popper: {
      placement: "bottom-start",
      modifiers: [{ name: "flip", enabled: false }],
    },
  }}
  options={customerecr}
  getOptionLabel={(option) => typeof option === "string" ? option : option.entry_no || ""}
  value={customerecr.find((ecr) => ecr.entry_no === data.challan_no) || (data.challan_no ? data.challan_no : null)}
  onChange={(event, newValue) => {
    handleChange({
      target: {
        name: "challan_no",
        value: newValue ? (typeof newValue === "string" ? newValue : newValue.entry_no) : "",
      },
    });
  }}
  isOptionEqualToValue={(option, value) =>
    option.entry_no === (typeof value === "string" ? value : value?.entry_no)
  }
  renderOption={(props, option) => (
    <MenuItem {...props} sx={menuItemSx}>{option.entry_no}</MenuItem>
  )}
  renderInput={(params) => (
    <TextField
      {...params}
      size="small"
      fullWidth
      placeholder="Select ECR Number"
      sx={selectSx}
    />
  )}
/>
                          {/* <Button
                            variant="contained" onClick={handlePrint}
                            sx={{ minWidth: "40px", px: 1.5, background: "#1C3A5E", borderRadius: "8px", "&:hover": { background: "#2a4f7c" } }}
                          >
                            <LocalPrintshopIcon sx={{ fontSize: 18 }} />
                          </Button> */}
                        </Box>
                      </Grid>
                    )}

                    {/* Delivery Challan No */}
                                     {data.option === "delivery_challan" && data.from_location !== "supplier" && (
                      <Grid item xs={7} sm={10}>
                        <Typography sx={fieldLabelSx}>Delivery Challan No</Typography>
                        <Box sx={{ display: "flex", gap: 1 }}>
                          <TextField
                            select name="challan_no" value={data.challan_no || ""}
                            onChange={handleChange} fullWidth size="small" sx={selectSx}
                          >
                            {/* <MenuItem value="" sx={menuItemSx}>Select Delivery Challan No</MenuItem> */}
                            {dcNoData.map(d => (
                              <MenuItem key={d.entry_id} value={d.entry_no} sx={menuItemSx}>{d.entry_no}</MenuItem>
                            ))}
                          </TextField>
                          {/* <Button
                            variant="contained" onClick={handlePrint}
                            sx={{ minWidth: "40px", px: 1.5, background: "#1C3A5E", borderRadius: "8px", "&:hover": { background: "#2a4f7c" } }}
                          >
                            <LocalPrintshopIcon sx={{ fontSize: 18 }} />
                          </Button> */}
                        </Box>
                      </Grid>
                    )}

                    {/* Empty Challan No */}
                    {data.from_location === "depot" && data.option === "empty_challan" && (
                      <Grid item xs={7} sm={10}>
                        <Typography sx={fieldLabelSx}>Empty Challan No</Typography>
                        {!data.from_depot_id && (
                          <Typography sx={{ fontSize: "11px", color: "#A0AEC0", mb: 0.5 }}>Select a depot first</Typography>
                        )}
                        <Box sx={{ display: "flex", gap: 1 }}>
                          <TextField
                            select name="empty_challan_no" value={data.empty_challan_no || ""}
                            onChange={handleChange} fullWidth size="small" sx={selectSx}
                            disabled={!data.from_depot_id}
                          >
                            {/* <MenuItem value="" disabled sx={menuItemSx}>
                              {data.from_depot_id ? "Select Empty Challan No" : "Select depot first"}
                            </MenuItem> */}
                            {data.from_depot_id && emptyNoData.map(d => (
                              <MenuItem key={d.entry_id || d.entry_no} value={d.entry_no} sx={menuItemSx}>{d.entry_no}</MenuItem>
                            ))}
                          </TextField>
                          {/* <Button
                            variant="contained" onClick={handlePrint}
                            disabled={!data.empty_challan_no}
                            sx={{ minWidth: "40px", px: 1.5, background: "#1C3A5E", borderRadius: "8px", "&:hover": { background: "#2a4f7c" } }}
                          >
                            <LocalPrintshopIcon sx={{ fontSize: 18 }} />
                          </Button> */}
                        </Box>
                      </Grid>
                    )}

                    {/* Supplier Challan No */}
                   {/* Supplier Challan No */}
                    {data.from_location === "supplier" && (
                      <Grid item xs={7} sm={10}>
                        <Typography sx={fieldLabelSx}>Supplier Challan No</Typography>
                        <Box sx={{ display: "flex", gap: 1 }}>
                          <TextField
                            name="supplier_challan_no" value={data.supplier_challan_no || ''}
                            onChange={handleChange} fullWidth size="small" sx={inputSx}
                            placeholder="Enter supplier challan no"
                          />
                        </Box>
                      </Grid>
                    )}

                    {/* Product Code — Supplier only */}
                  
                    <Grid item xs={7} sm={10}>
  <Typography sx={fieldLabelSx}>Product Code</Typography>
  <Autocomplete
    disablePortal fullWidth options={product}
    disabled={data.from_location !== 'supplier'}
    componentsProps={{
      popper: {
        placement: "bottom-start",
        modifiers: [{ name: "flip", enabled: false }],
      },
    }}
    getOptionLabel={o => o.prod_code || ''}
    value={product.find(o => o.prod_code === (data?.prod_code || "DA001")) || null}
    onChange={(e, nv) => setData(prev => ({ ...prev, prod_code: nv ? nv.prod_code : '', prod_id: nv ? nv.prod_id : null }))}
    isOptionEqualToValue={(o, v) => o.prod_code === v.prod_code}
    renderOption={(props, option) => <MenuItem {...props} sx={menuItemSx}>{option.prod_code}</MenuItem>}
    renderInput={(params) => acInput(params, "Select product")}
  />
</Grid>
                    

                  </Grid>
                </Grid>

                {/* ════════ RIGHT COLUMN — Entry & Vehicle Info ════════ */}
                <Grid
                  item xs={12} md={6}
                  sx={{ p: 2.5, background: "#FAFBFC", pl: 3.5 }}
                >
                  <Grid container spacing={1.5}>

                    {/* Entry No */}
                    <Grid item xs={7} sm={5}>
                      <Typography sx={fieldLabelSx}>Entry No</Typography>
                      <TextField
                        size="small" fullWidth value={data.entry_no}
                        sx={readonlyInputSx} InputProps={{ readOnly: true }}
                        placeholder="Auto-generated"
                      />
                    </Grid>

                    {/* Entry Date */}
                    <Grid item xs={7} sm={5}>
                      <Typography sx={fieldLabelSx}>
                        Entry Date <span style={{ color: "#E53E3E" }}>*</span>
                      </Typography>
                      <DatePicker
                        format="DD/MM/YYYY"
                        value={dayjs(data.entry_date, "DD/MM/YYYY")}
                        onChange={nv => handleChange({ target: { name: "entry_date", value: nv } })}
                        slotProps={{ textField: { size: "small", fullWidth: true, required: true, sx: inputSx } }}
                      />
                    </Grid>
                   <Grid item xs={7} sm={5}>
  <Typography sx={fieldLabelSx}>Driver Name</Typography>
  {data.from_location === "supplier" ? (
    <TextField
      name="driver_name" size="small" fullWidth value={data.driver_name || ""}
      onChange={handleChange} sx={inputSx}
      placeholder="Enter driver name"
    />
  ) : (
    <TextField
      size="small" fullWidth value={data.driver_name || ""}
      sx={readonlyInputSx} InputProps={{ readOnly: true }}
      placeholder="Auto-filled from challan"
    />
  )}
</Grid>

<Grid item xs={7} sm={5}>
  <Typography sx={fieldLabelSx}>Vehicle No</Typography>
  {data.from_location === "supplier" ? (
    <TextField
      name="vehicle_no" size="small" fullWidth value={data.vehicle_no || ""}
      onChange={handleChange} sx={inputSx}
      placeholder="Enter vehicle no"
    />
  ) : (
    <TextField
      size="small" fullWidth value={data.vehicle_no || ""}
      sx={readonlyInputSx} InputProps={{ readOnly: true }}
      placeholder="Auto-filled from challan"
    />
  )}
</Grid>

                    {/* Driver Name */}
                    

                   
                    {/* <Grid item xs={7} sm={5}>
                      <Typography sx={fieldLabelSx}>Product Code</Typography>
                      <Autocomplete
                        disablePortal fullWidth options={product}
                        componentsProps={{
                          popper: {
                            placement: "bottom-start",
                            modifiers: [{ name: "flip", enabled: false }],
                          },
                        }}
                        getOptionLabel={o => o.prod_code || ''}
                        value={product.find(o => o.prod_code === (data?.prod_code || "DA001")) || null}
                        onChange={(e, nv) => handleChange({ target: { name: 'prod_code', value: nv ? nv.prod_code : '' } })}
                        isOptionEqualToValue={(o, v) => o.prod_code === v.prod_code}
                        renderInput={(params) => acInput(params, "Select product")}
                      />
                    </Grid> */}

                  </Grid>
                </Grid>

              </Grid>
            </Box>
          </Box>

          {/* ── Cylinders Table ──────────────────────────────────────── */}
          <Box sx={formCardSx}>
            <TableContainer>
              <Table size="small" stickyHeader>
                <TableHead>
               <tr style={{ background: "#1C3A5E" }}>
                   {["Sr No", "Cylinder No", "Tag No", "Owner", "Status",  "Remarks",...(data.option === "delivery_challan" && data.from_location !== "depot" ? ["Qty (CUM)"] : []), data.from_location === "supplier" ? "Action" : "Check"].map(h => (
                      <th
                        key={h}
                        style={{
                          background: "#1C3A5E", color: "#fff", fontSize: "12px",
                          fontWeight: 600, fontFamily: "'Inter', Arial, sans-serif",
                          padding: "10px 12px", borderRight: "1px solid rgba(255,255,255,0.1)",
                          whiteSpace: "nowrap",
                          textAlign: h === "Check" ? "center" : "left",
                        }}
                      >{h}</th>
                    ))}
                  </tr>
                </TableHead>
<TableBody>
                
                  {filteredCylinders.map((row, index) => (
                 <tr
                      key={index}
                      onClick={e => { if (data.from_location !== "supplier" && e.target.type !== 'number') handleCheckClick(index); }}
                      style={{ background: index % 2 === 0 ? "#fff" : "#F8FAFC", cursor: data.from_location === "supplier" ? "default" : "pointer", borderBottom: "1px solid #E2E8F0" }}
                      onMouseEnter={e => e.currentTarget.style.background = "#EBF4FF"}
                      onMouseLeave={e => e.currentTarget.style.background = index % 2 === 0 ? "#fff" : "#F8FAFC"}
                    >
                      <td style={{ padding: "8px 12px", fontSize: "13px", fontFamily: "'Inter', Arial, sans-serif", color: "#2D3748" }}>{index + 1}</td>

                      {data.from_location === "supplier" ? (
                        <>
                          <td style={{ padding: "4px 8px" }}>
                            <TextField size="small" fullWidth name="cyl_no" placeholder="Cyl No" value={row.cyl_no}
                              onChange={e => handleChangeSupplierRow(e, index)} variant="standard"
                              InputProps={{ disableUnderline: true }} sx={{ "& input": { fontSize: "13px" } }} />
                          </td>
                          <td style={{ padding: "4px 8px" }}>
                            <TextField size="small" fullWidth name="tag_no" placeholder="Tag No" value={row.tag_no}
                              onChange={e => handleChangeSupplierRow(e, index)} variant="standard"
                              InputProps={{ disableUnderline: true }} sx={{ "& input": { fontSize: "13px" } }} />
                          </td>
                          <td style={{ padding: "4px 8px" }}>
                            <TextField size="small" fullWidth name="owner" placeholder="Owner" value={row.owner}
                              onChange={e => handleChangeSupplierRow(e, index)} variant="standard"
                              InputProps={{ disableUnderline: true }} sx={{ "& input": { fontSize: "13px" } }} />
                          </td>
                          <td style={{ padding: "4px 8px" }}>
                            <TextField select size="small" fullWidth name="status" value={row.status || "Empty"}
                              onChange={e => handleChangeSupplierRow(e, index)} variant="standard"
                              InputProps={{ disableUnderline: true }} sx={{ "& .MuiSelect-select": { fontSize: "13px" } }}>
                              <MenuItem value="Empty" sx={menuItemSx}>Empty</MenuItem>
                              <MenuItem value="Full" sx={menuItemSx}>Full</MenuItem>
                            </TextField>
                          </td>
                         
                          <td style={{ padding: "4px 8px" }}>
                            <TextField size="small" fullWidth name="remark" placeholder="Remarks" value={row.remark}
                              onChange={e => handleChangeSupplierRow(e, index)} variant="standard"
                              InputProps={{ disableUnderline: true }} sx={{ "& input": { fontSize: "13px" } }} />
                          </td>
                          {data.option === "delivery_challan" && data.from_location !== "depot" && (
                            <td style={{ padding: "4px 8px" }}>
                              <TextField type="number" size="small" fullWidth name="qty" value={row.qty}
                                onChange={e => handleChangeSupplierRow(e, index)} variant="standard"
                                InputProps={{ disableUnderline: true }} sx={{ "& input": { fontSize: "13px" } }} />
                            </td>
                          )}
                          <td style={{ padding: "8px 12px", textAlign: "center" }}>
                            <Box sx={{ display: "flex", justifyContent: "center", gap: 0.5 }}>
                              <IconButton size="small" onClick={handleAddSupplierRow}>
                                <AddCircleOutlineIcon sx={{ fontSize: 18, color: "#2B6CB0" }} />
                              </IconButton>
                              <IconButton size="small" disabled={index === 0 && filteredCylinders.length === 1} onClick={() => handleRemoveSupplierRow(index)}>
                                <DeleteForeverIcon sx={{ fontSize: 18, color: (index === 0 && filteredCylinders.length === 1) ? "#c0c0c0" : "#E53E3E" }} />
                              </IconButton>
                            </Box>
                          </td>
                        </>
                      ) : (
                        <>
                          <td style={{ padding: "8px 12px", fontSize: "13px", fontFamily: "'Inter', Arial, sans-serif", color: "#2D3748" }}>{row.cyl_no || row.cylinder_no || "—"}</td>
                          <td style={{ padding: "8px 12px", fontSize: "13px", fontFamily: "'Inter', Arial, sans-serif", color: "#2D3748" }}>{row.tag_no}</td>
                          <td style={{ padding: "8px 12px", fontSize: "13px", fontFamily: "'Inter', Arial, sans-serif", color: "#2D3748" }}>{row.owner === 'TGPL' ? 'TGPL' : row.customer_name || row.owner}</td>
                          <td style={{ padding: "8px 12px", fontSize: "13px", fontFamily: "'Inter', Arial, sans-serif", color: "#2D3748" }}>
                            <Box sx={{ display: "inline-flex", alignItems: "center", px: 1.5, py: 0.3, borderRadius: "20px", fontSize: "13px", fontWeight: 600, background: row.status === "Full" ? "#FFF5F5" : "#F0FFF4", color: row.status === "Full" ? "#E53E3E" : "#38A169" }}>
                              {row.status}
                            </Box>
                          </td>
                            <td style={{ padding: "8px 12px", fontSize: "13px", fontFamily: "'Inter', Arial, sans-serif", color: "#718096" }}>{row.remark || '-'}</td>
                         {data.option === "delivery_challan" && data.from_location !== "depot" && (
                            <td style={{ padding: "8px 12px" }}>
                              <TextField
                                type="number" size="small" value={row.qty}
                                onChange={e => handleQtyChange(index, e.target.value)}
                                sx={{ width: "80px", "& .MuiOutlinedInput-root": { height: "30px", fontSize: "13px", borderRadius: "6px" } }}
                              />
                            </td>
                          )}
                          <td style={{ padding: "8px 12px", textAlign: "center" }}>
                            <input
                              type="checkbox" checked={!!row.checked}
                              onChange={() => handleCheckClick(index)}
                              onClick={e => e.stopPropagation()}
                              style={{ width: "16px", height: "16px", cursor: "pointer", accentColor: "#4CAF50" }}
                            />
                          </td>
                        </>
                      )}
                    </tr>
                  ))}
                  {filteredCylinders.length === 0 && (
                    <tr>
                      <td colSpan={8} style={{ padding: "32px", textAlign: "center", color: "#A0AEC0", fontSize: "13px", fontFamily: "'Inter', Arial, sans-serif" }}>
                        No cylinders added yet. Select a challan above or add manually.
                      </td>
                    </tr>
                  )}
                </TableBody>
              </Table>
            </TableContainer>

            {/* Footer Buttons */}
            <Box sx={formFooterSx}>
              <Button sx={cancelBtnSx} onClick={() => navigate(-1)}>Cancel</Button>
              <Button type="submit" sx={saveBtnSx} disabled={isSubmitting}>
                <SaveIcon sx={{ fontSize: 18 }} />
                {isSubmitting ? "Saving..." : editData ? "Update" : "Save"}
              </Button>
            </Box>
          </Box>
        </form>

        {/* ── Confirm Modal ─────────────────────────────────────────── */}
        <Dialog
          open={confirmModal.open} onClose={() => handleConfirmCheck(false)}
          PaperProps={{ sx: { borderRadius: "12px", border: "1px solid #E2E8F0", minWidth: "320px" } }}
        >
          <DialogTitle sx={{ fontSize: "14px", fontWeight: 700, color: "#1C3A5E", fontFamily: "'Inter', Arial, sans-serif", pb: 1 }}>Confirm Action</DialogTitle>
          <DialogContent>
            <Typography sx={{ fontSize: "13px", color: "#4A5568", fontFamily: "'Inter', Arial, sans-serif" }}>
              {confirmModal.checked ? `Mark Cylinder #${confirmModal.cylinder_no} as received?` : `Remove check from Cylinder #${confirmModal.cylinder_no}?`}
            </Typography>
          </DialogContent>
          <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
            <Button onClick={() => handleConfirmCheck(false)} sx={{ ...cancelBtnSx, height: "34px", fontSize: "13px" }}>No</Button>
            <Button onClick={() => handleConfirmCheck(true)} sx={{ ...saveBtnSx, height: "34px", fontSize: "13px" }}>Yes</Button>
          </DialogActions>
        </Dialog>

        {/* ── Add Cylinder Dialog ───────────────────────────────────── */}
        <Dialog
          open={openDialog} onClose={handleCloseDialog} maxWidth="sm" fullWidth
          PaperProps={{ sx: { borderRadius: "14px", border: "1px solid #E2E8F0" } }}
        >
          <Box sx={{ background: "#1C3A5E", padding: "14px 22px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#fff", fontFamily: "'Inter', Arial, sans-serif" }}>
              {editIndex !== null ? 'Edit Cylinder' : isMultiDialog ? 'Add Multiple Cylinders' : 'Add Single Cylinder'}
            </Typography>
            <CancelIcon onClick={handleCloseDialog} sx={{ color: "rgba(255,255,255,0.7)", cursor: "pointer", fontSize: 20, "&:hover": { color: "#fff" } }} />
          </Box>

          <DialogContent sx={{ pt: 3, pb: 1 }}>
            {isMultiDialog ? (
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 2 }}>
                    <Button
                      onClick={isScannerOpen ? stopScanner : startScanner}
                      variant="contained"
                      sx={{ width: "50%", height: "44px", background: isScannerOpen ? "linear-gradient(45deg, #d32f2f 30%, #ef5350 90%)" : "linear-gradient(45deg, #2e7d32 30%, #66bb6a 90%)", color: "#fff", borderRadius: "8px", textTransform: "none", fontWeight: 600, fontSize: "14px", fontFamily: "'Inter', Arial, sans-serif", gap: 1 }}
                    >
                      <CameraAltSharpIcon sx={{ fontSize: 18 }} /> {isScannerOpen ? 'Stop Scanner' : 'Scan QR'}
                    </Button>
                    <Typography sx={{ fontSize: "12px", color: "#A0AEC0" }}>— or —</Typography>
                    <Box sx={{ display: "flex", width: "100%", gap: 1 }}>
                      <TextField size="small" fullWidth name="cyl_nos" value={multiDialogData.cyl_nos} onChange={handleMultiDialogChange} placeholder="e.g., CYL001, CYL002" sx={inputSx} />
                      <Button onClick={handleDialogSubmit} variant="contained" sx={{ ...saveBtnSx, height: "38px", px: 2.5, fontSize: "13px" }}>Add</Button>
                    </Box>
                    <Typography sx={{ fontSize: "11px", color: "#718096", alignSelf: "flex-start" }}>Cylinder Numbers (comma-separated)</Typography>
                  </Box>
                </Grid>
                {isScannerOpen && (
                  <Grid item xs={12}>
                    <Box sx={{ border: "1px solid #E2E8F0", borderRadius: "10px", p: 2, display: "flex", flexDirection: "column", alignItems: "center" }}>
                      <Typography sx={{ fontSize: "13px", fontWeight: 600, color: "#1C3A5E", mb: 1 }}>QR Scanner</Typography>
                      <div id={qrCodeRegionId} style={{ width: "100%", maxWidth: "380px", minHeight: "280px" }} />
                      {scanResults.length > 0 && (
                        <Box sx={{ mt: 2, width: "100%", maxHeight: "120px", overflow: "auto", borderTop: "1px solid #E2E8F0", pt: 1 }}>
                          <Typography sx={{ fontSize: "12px", fontWeight: 600, color: "#2063b6" }}>Scanned:</Typography>
                          <List dense>{scanResults.map((r, i) => <ListItem key={i} sx={{ py: 0 }}><ListItemText primary={r} primaryTypographyProps={{ fontSize: "12px" }} /></ListItem>)}</List>
                        </Box>
                      )}
                    </Box>
                  </Grid>
                )}
              </Grid>
            ) : (
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 2 }}>
                    <Button
                      onClick={isScannerOpen ? stopScanner : startScanner}
                      variant="contained"
                      sx={{ width: "50%", height: "44px", background: isScannerOpen ? "linear-gradient(45deg, #f44336 30%, #e57373 90%)" : "linear-gradient(45deg, #2196f3 30%, #64b5f6 90%)", color: "#fff", borderRadius: "8px", textTransform: "none", fontWeight: 600, fontSize: "14px", fontFamily: "'Inter', Arial, sans-serif", gap: 1 }}
                    >
                      <CameraAltSharpIcon sx={{ fontSize: 18 }} /> {isScannerOpen ? 'Stop Scanner' : 'Scan QR'}
                    </Button>
                    <Typography sx={{ fontSize: "12px", color: "#A0AEC0" }}>— or —</Typography>
                    <Box sx={{ display: "flex", width: "100%", gap: 1 }}>
                      <TextField size="small" fullWidth name="cyl_no" value={dialogData.cyl_no} onChange={handleDialogChange} placeholder="Enter Cylinder No" sx={inputSx} />
                      <Button onClick={handleDialogSubmit} variant="contained" sx={{ ...saveBtnSx, height: "38px", px: 2.5, fontSize: "13px" }}>Add</Button>
                    </Box>
                  </Box>
                  {dialogData.cyl_no && (
                    <Box sx={{ display: "flex", gap: 3, mt: 1.5, p: 1.5, background: "#F8FAFC", borderRadius: "8px", border: "1px solid #E2E8F0" }}>
                      <Typography sx={{ fontSize: "12px", color: "#2063b6" }}>Cyl No: <strong>{dialogData.cyl_no}</strong></Typography>
                      <Typography sx={{ fontSize: "12px", color: "#2063b6" }}>Tag No: <strong>{dialogData.tag_no}</strong></Typography>
                      <Typography sx={{ fontSize: "12px", color: "#2063b6" }}>Owner: <strong>{dialogData.owner}</strong></Typography>
                    </Box>
                  )}
                </Grid>
                <Grid item xs={12}><Box sx={{ borderTop: "1px solid #E2E8F0" }} /></Grid>
                <Grid item xs={12} sm={6}>
                  <Typography sx={fieldLabelSx}>State</Typography>
                  <TextField select size="small" fullWidth name="state" value={dialogData.state || 'Empty'} onChange={handleDialogChange} sx={selectSx}>
                    <MenuItem value="Empty" sx={{ ...menuItemSx, color: "#38A169" }}>Empty</MenuItem>
                    <MenuItem value="Full" sx={{ ...menuItemSx, color: "#E53E3E" }}>Full</MenuItem>
                  </TextField>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography sx={fieldLabelSx}>Reason</Typography>
                  <TextField size="small" fullWidth name="reason" value={dialogData.reason} onChange={handleDialogChange} sx={inputSx} placeholder="Enter reason" />
                </Grid>
                {isScannerOpen && (
                  <Grid item xs={12}>
                    <Box sx={{ border: "1px solid #E2E8F0", borderRadius: "10px", p: 2, display: "flex", flexDirection: "column", alignItems: "center" }}>
                      <Typography sx={{ fontSize: "13px", fontWeight: 600, color: "#1C3A5E", mb: 1 }}>QR Scanner</Typography>
                      <div id={qrCodeRegionId} style={{ width: "100%", maxWidth: "380px", minHeight: "280px" }} />
                      {scanResults.length > 0 && (
                        <Box sx={{ mt: 2, width: "100%", maxHeight: "120px", overflow: "auto", borderTop: "1px solid #E2E8F0", pt: 1 }}>
                          <Typography sx={{ fontSize: "12px", fontWeight: 600, color: "#2063b6" }}>Scanned:</Typography>
                          <List dense>{scanResults.map((r, i) => <ListItem key={i} sx={{ py: 0 }}><ListItemText primary={r} primaryTypographyProps={{ fontSize: "12px" }} /></ListItem>)}</List>
                        </Box>
                      )}
                    </Box>
                  </Grid>
                )}
              </Grid>
            )}
          </DialogContent>

          <DialogActions sx={{ px: 3, pb: 2.5, justifyContent: "center" }}>
            <Button onClick={handleCloseDialog} variant="contained" sx={{ ...saveBtnSx, width: "50%", height: "40px" }}>Done</Button>
          </DialogActions>
        </Dialog>

        <ReusableSnackbar
          open={!!successMessage}
          onClose={(e, reason) => { if (reason !== 'clickaway') { setSuccessMessage(""); setOpenSnackbar(false); } }}
          message={successMessage}
          autoHideDuration={2000}
          vertical="top"
          horizontal="right"
        />
      </Box>
    </LocalizationProvider>
  );
};

export default CylinderInwardAdd;